import { formatters, ValueInput } from '@utils/formattersV2';
import { theme } from '../domain/theme';
import { CSSObject, SeriesOptionsType } from 'highcharts';
import { baseChart } from '../../../configurations/campaignAnalytics/baseChart';

const DARK_BLUE = '#253861';
const BLUE = '#4E71BE';
const TRANSPARENT = 'rgba(0,0,0,0)';
const GRID_LINE_COLOR = '#424242';

const colors = [DARK_BLUE, BLUE, theme.colors.lightBlue] as const;

const defaultLabelStyle: CSSObject = {
  textOutline: 'none',
  color: theme.colors.white,
  fontSize: '22',
  fontWeight: 'normal',
};

export type SalesOptimizationChartOptions = {
  data: {
    sales: number;
    lift: number;
    label: string;
    salesFormatterOverride?: (value: ValueInput) => string;
  }[];
};

export const salesOptimizationChart = (
  options: SalesOptimizationChartOptions
): Highcharts.Options => ({
  ...baseChart,
  chart: {
    backgroundColor: TRANSPARENT,
    spacingRight: 150,
  },
  plotOptions: {
    column: {
      stacking: 'normal',
      borderWidth: 0,
    },
  },
  xAxis: {
    type: 'category',
    labels: {
      enabled: false,
    },
    lineWidth: 0,
  },
  yAxis: {
    gridLineColor: GRID_LINE_COLOR,
    title: {
      text: undefined,
    },
    labels: {
      style: {
        color: theme.colors.white,
      },
      formatter() {
        return formatters.number(Number(this.value) * 100, { decimals: 0 });
      },
    },
  },
  series: options.data
    .toSorted((a, b) => a.lift - b.lift)
    .map(
      (
        { sales, lift, label, salesFormatterOverride },
        index
      ): SeriesOptionsType => ({
        type: 'column',
        name: label,
        data: [lift],
        color: colors[index],
        dataLabels: [
          {
            enabled: true,
            crop: false,
            style: defaultLabelStyle,
            formatter() {
              if (salesFormatterOverride) {
                return salesFormatterOverride(sales);
              }
              if (label === 'Transaction Size') {
                return formatters.currency(sales, { decimals: 0, full: true });
              }
              if (label === 'Transaction Rate') {
                return formatters.number(sales, { decimals: 1 });
              }
              return formatters.percentage(sales, { decimals: 1 });
            },
          },
          {
            enabled: true,
            align: 'left',
            x: 210,
            overflow: 'allow',
            crop: false,
            style: defaultLabelStyle,
            formatter() {
              return formatters.percentage(lift, {
                decimals: 1,
              });
            },
          },
          {
            enabled: true,
            align: 'left',
            x: 290,
            overflow: 'allow',
            crop: false,
            style: {
              ...defaultLabelStyle,
              fontSize: '12',
              fontWeight: 'bold',
            },
            formatter() {
              return label.toUpperCase();
            },
          },
        ],
      })
    ),
});
